var map = {
	"./automated-allergens.png": 9468,
	"./bulk-edit-poster.webp": 6760,
	"./cost-decisions-2.png": 138,
	"./cost-decisions.png": 9929,
	"./custom-ingredient-list.png": 9741,
	"./custom-label.png": 2774,
	"./customize-label-poster.webp": 7029,
	"./easy-cost-entry.png": 4228,
	"./features-analysis.png": 6611,
	"./features-costing.png": 5677,
	"./features-ingredient-list.png": 7471,
	"./features-labeling.png": 2827,
	"./features-recipe-mgmt.png": 5025,
	"./features-supplement-labels.png": 4683,
	"./flexible-database.png": 1669,
	"./intuitive-nutrition-interface.png": 4815,
	"./label_styles_image_merged.png": 475,
	"./macro.png": 6977,
	"./multiple-devices.png": 6355,
	"./nutrition-label-preview-poster.webp": 5270,
	"./pro-features.png": 3667,
	"./production-run-shortage2.png": 3124
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2221;